import React, { useState } from 'react'
import {
  AppBar,
  Box,
  Button,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  IconButton
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import MenuIcon from '@mui/icons-material/Menu'
import CallIcon from '@mui/icons-material/Call'

import './navbar.css'
import logo from '../../_contentnew/pulsepalletslogo.webp'

const pages = [
  { name: 'Home', link: '/' },
  { name: 'About', link: '/about' },
  { name: 'Pallets', link: '/pallets' },
  { name: 'Services', link: '/services' },
  { name: 'Contact', link: '/contact' }
]

const Navbar = () => {
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = (link) => {
    if (link) {
      navigate(link)
      window.scrollTo(0, 0)
    }

    setAnchorEl(null)
  }

  const navigateLink = (link) => {
    navigate(link)
    window.scrollTo(0, 0)
  }

  return (
    <>
      <Box className="mobile-topbar">
        <CallIcon sx={{ fontSize: '18px', mr: 1 }} />
        <a href="tel:+447862079920">
          07862 079920
        </a>
      </Box>

      <AppBar className="navbar" position="sticky" elevation={0}>
        <Toolbar className="navbar-toolbar">
          <Button
            className="navbar-logo"
            disableRipple
            onClick={() => navigate('/')}
          >
            <img src={logo} alt="Pulse Pallets" />
          </Button>

          <Box className="navbar-links">
            {pages.map(({ name, link }) => (
              <Button
                key={name}
                className="navbar-button"
                onClick={() => navigateLink(link)}
              >
                {name}
              </Button>
            ))}
          </Box>

          <Box
            component="a"
            href="tel:+447862079920"
            className="navbar-contact"
          >
            <CallIcon sx={{ mr: 1 }} />

            <Typography
              className="contact-text"
              variant="body1"
            >
              Get A Quote
            </Typography>
          </Box>

          <IconButton
            edge="end"
            className="navbar-menu-button"
            onClick={handleMenuOpen}
          >
            <MenuIcon />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => handleMenuClose(null)}
            disableScrollLock
          >
            {pages.map(({ name, link }) => (
              <MenuItem
                key={name}
                onClick={() => handleMenuClose(link)}
              >
                {name}
              </MenuItem>
            ))}

            <MenuItem
              component="a"
              href="tel:+447862079920"
              sx={{
                color: '#57C84D',
                fontWeight: 700
              }}
            >
              Get A Quote
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
    </>
  )
}

export default Navbar